/**************
 Cart
 ***************/


// open cart
async function openCart(skipFetch = false) {
    // reset container
    document.querySelector("#miniCartBody").innerHTML = "";

    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }

    // update active body
    if (cart.item_count === 0) {
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartContentNote").classList.add("hidden");
        document.querySelector("#miniCartContentUpsell").classList.add("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
    } else {
        document.querySelector("#miniCartBody").classList.add("active");
        document.querySelector("#miniCartEmpty").classList.remove("active");
        document.querySelector("#miniCartContentNote").classList.remove("hidden");
        document.querySelector("#miniCartContentUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.add("active");


        // update subtotal
        document.querySelector("#miniCartFooterSubtotal span:last-child").textContent = price(cart.items_subtotal_price);
    }

    // append cart
    cart.items.forEach(function (item) {
        console.log("ITEM", item)
        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemTitle">${item.product_title}</div>
                    ${item.variant_title !== null ? `<div class='miniCartBodyItemTitle'>${item.variant_title}</div> ` : ''}
                    ${subscriptionHTML()}
                    ${item.properties ? 
                        Object.entries(item.properties).map(([key, value]) => {
                            if (value !== null && value !== undefined && value !== "" && key !== "_grouping") {
                                return `<div class="cartBodyItemTitle">${key}: ${value}</div>`;
                            }
                            return '';
                        }).join('') 
                        : ''
                    }
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">-</button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">+</button>
                    </div>
                </div>
                <div>
                    <button class="miniCartBodyItemRemove">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.79824 2.87143L0.00496205 2.86399L0 4.61623L1.74788 4.6209L2.58593 15H12.4141L13.2496 4.65181L14.995 4.65648L15 2.90416L12.2018 2.89671V0H2.79824V2.87143ZM3.54751 4.62575L4.2437 13.2477H6.60315H10.7563L11.4508 4.64696L3.54751 4.62575ZM5.07121 6.33298L5.11764 11.8659L6.91124 11.8516L6.8649 6.31861L5.07121 6.33298ZM8.08876 6.33298L8.1351 11.8659L9.92879 11.8516L9.88236 6.31861L8.08876 6.33298ZM4.59193 2.87628L10.4081 2.89186L10.4082 1.75233H4.59193V2.87628Z" fill="#A7A7A7"/>
                        </svg>                    
                    </button>
                    <div class="miniCartBodyItemPrice">${price(item.final_line_price)} <s>${item.original_line_price > item.final_line_price ? price(item.original_line_price) : ""}</s></div>
                </div>
            </div>
           
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity == 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            let response = await changeProduct({
                id: key,
                quantity: quantity
            });
            // check for error
            if (response.status === 422) {
                alert("No more in stock.");
            } else {
                cart = response;
            }
            // update active body
            await openCart(true);
        }


    });

    //faq event listeners for each of the questions
    document.querySelector(`#miniCartContentNoteTitle`).addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartContentUpsellBodyWrapItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // there must be at least 1 active product upsell to show container
    if (document.querySelectorAll(".miniCartContentUpsellBodyWrapItem.active").length === 0) {
        document.querySelector("#miniCartContentUpsell").classList.add("active");
    } else {
        document.querySelector("#miniCartContentUpsell").classList.remove("active");
    }

    // show upsell
    document.querySelector("#miniCart").showModal();
    document.querySelector("body").classList.add("noScroll");
}


// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // update order note if it does not match shopify
    if (document.querySelector("#miniCartContentNoteBodyTextarea").value !== cart.note) {
        await updateCart({"note": document.querySelector("#miniCartContentNoteBodyTextarea").value});
    }

    this.classList.remove("loading");

    // update note
    await updateCart()

    window.location.href = "/checkout";
});

// close cart
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// open returns dialog
document.querySelector("#miniCartFooterIconsReturns").addEventListener("click", function () {
    document.querySelector("#returns").showModal();
});

// close quick add
function closeReturns() {
    document.querySelector("#returns").close();
}

//close quick add listener
document.querySelector(".closeReturns").addEventListener("click", function () {
    closeReturns();
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#returns"));


// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


/**************
 QUICK ADD
 ***************/

// open quick add dialog
function openQuickAdd(id) {
    // open dialog
    document.querySelector(`#quickAdd-${id}`).showModal();
    document.querySelector("body").classList.add("noScroll");
}


// open quick add event listener
document.querySelectorAll(".openQuickAdd").forEach(function (element) {
    element.addEventListener("click", function () {
        openQuickAdd(this.dataset.id);
    });
});

// close quick add
function closeQuickAdd(id) {
    document.querySelector(`#quickAdd-${id}`).close();
}

//close quick add listener
document.querySelectorAll(".closeQuickAdd").forEach(function (element) {
    element.addEventListener("click", function () {
        closeQuickAdd(this.dataset.id);
    });
});

// register dialogs
document.querySelectorAll(".quickAdd").forEach(function (element) {
    dialogPolyfill.registerDialog(document.querySelector(`.quickAdd#${element.id}`));
});

/**************
 Product Variants Upsell
 ***************/
let upsellActiveVariant = null;
// update active variant on input changes
document.querySelectorAll(".quickAdd input").forEach(function (element) {
    element.addEventListener("change", function () {

        let product = JSON.parse(this.dataset.product);
        // collect upsellOptions from inputs
        let options = [];

        // upsellOptions from radio
        document.querySelectorAll(`input.quickAddContentBodyItemOptionsBodyRadioInput:checked`).forEach(element => {
            options.push(element.value);
        });


        // find new variant based on the upsellOptions
        upsellActiveVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });

        // check if variant wasn't found
        if (!upsellActiveVariant) {
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).disabled = true;
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).textContent = "Not Available";
            return;
        }

        // check if the variant is in stock
        if (upsellActiveVariant.available) {
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).disabled = false;
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).textContent = "Add To Cart";
        } else {
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).disabled = true;
            document.querySelector(`#quickAddBtn-${this.dataset.id}`).textContent = "Sold Out";
        }
    });
})

/**************
 UPSELL ATC
 ***************/
document.querySelectorAll(".quickAddContentATC").forEach(function (element) {
    element.addEventListener("click", async function () {

        // if only default variant
        if (upsellActiveVariant === null) {
            upsellActiveVariant = JSON.parse(this.dataset.defaultVariant);
        }


        this.classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: upsellActiveVariant.id,
            }]
        };

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart()

        //close quick add
        closeQuickAdd(this.dataset.id);

        // reset variant to null
        upsellActiveVariant = null;
    });

});
